/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text } from 'bold-ui'

interface ObservacaoProps {
  observacao?: string
}

export const Observacao = (props: ObservacaoProps) => {
  const { observacao } = props
  if (!observacao) {
    return null
  }
  return (
    <HFlow hSpacing={0.2} style={{ padding: '0.5rem 0' }}>
      <Text fontWeight='bold'>Observações: </Text>
      <Text
        fontStyle='italic'
        style={css`
          word-break: break-all;
        `}
      >
        {props.observacao}
      </Text>
    </HFlow>
  )
}
